import { ID, IDPrefixes } from '@griply/types';
import {
  buildLinkUpdates,
  createPrefixId,
  LinkDocumentSide,
} from '@griply/utils';
import { useCallback } from 'react';
import { useRelationshipIdsById } from 'shared/hooks/use-relationships';
import { useUpdateRelationshipsReferences } from 'shared/hooks/use-update-relationships-references';

export const useUpdateTaskRelationships = (
  id: ID,
  relationType: IDPrefixes,
) => {
  const taskRelationships = useRelationshipIdsById(id, IDPrefixes.Task);
  const updateRelationshipsReferences = useUpdateRelationshipsReferences();

  return useCallback(
    (relationTypeIds: ID[]) => {
      const updates = buildLinkUpdates({
        linkingId: createPrefixId(id, IDPrefixes.Task),
        targetPrefix: relationType,
        desiredIds: relationTypeIds,
        currentIds: taskRelationships[relationType],
        side: LinkDocumentSide.Linked,
      });

      if (!updates.length) {
        return;
      }

      updateRelationshipsReferences(updates);
    },
    [id, relationType, taskRelationships, updateRelationshipsReferences],
  );
};
